import { Box } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  flexDir: 'row',
});
